import { BuyInInfo } from 'types/game';
import { formatCurrencyAmount } from 'lib/currency-format';

export function buyInBlockMessage(info: {
  joinBlockReason?: BuyInInfo['joinBlockReason'];
  minBuyIn: number;
  currencySymbol: string;
  currencyCode?: string | null;
}): string {
  const minLabel = formatCurrencyAmount(info.currencySymbol, info.minBuyIn, info.currencyCode);

  switch (info.joinBlockReason) {
    case 'balance_unverified':
      return 'Could not verify your wallet — refresh the page and try again';
    case 'funds_on_table':
      return `Your chips are on a live table. Rejoin that table or leave it first (min buy-in ${minLabel})`;
    case 'insufficient_wallet':
    default:
      return `Insufficient wallet balance — minimum buy-in is ${minLabel}`;
  }
}
